/**
 * @file CityNoRbtYet.jsx
 * @description One line for behavior technicians who do not hold the RBT yet (persona review 2026-10-20: a new BT
 *   could not tell whether she could work now). BT openings need no certification; some Medicaid cases need the RBT
 *   (named the way the state does: Medi-Cal in California, from the seoAreas states table); the RBT guide is one tap away.
 * @module components/cityRole/CityNoRbtYet
 */
import { useTranslation } from "react-i18next";
import { T } from "../../theme";
import { AwardIcon, ArrowRightIcon } from "../Icons";
import { seoHref } from "../../lib/seo";

export default function CityNoRbtYet({ onNavigate, isMobile, state }) {
  const { t, i18n } = useTranslation();
  const isEs = i18n.language?.startsWith("es");
  const medicaid = (isEs && state?.medicaidNameEs) || state?.medicaidName;
  return (
    <div data-testid="city-no-rbt-yet" style={{ background: "#ecfdf5", borderBottom: "1px solid #a7f3d0", padding: isMobile ? "16px 18px" : "18px 48px" }}>
      <div style={{ maxWidth: 980, margin: "0 auto", display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <AwardIcon size={18} color={T.green} />
        <span style={{ fontSize: 14.5, color: "#065f46", fontWeight: 800 }}>{t("cityRole.noRbtTitle", "No RBT yet?")}</span>
        {/* Florida Medicaid requires the RBT on every case (since 2019); California names Medi-Cal; where the Medicaid
            rule is not sourced (seoAreas states table has no medicaidName) the strip makes no Medicaid claim. */}
        <span style={{ fontSize: 14, color: "#065f46", fontWeight: 500 }}>
          {state?.medicaidRequiresRbt
            ? t("cityRole.noRbtBodyAll", "BT openings don't need it. {{medicaid}} cases do.", { medicaid })
            : state?.medicaidName
              ? t("cityRole.noRbtBody", "BT openings don't need it. Some {{medicaid}} cases do.", { medicaid })
              : t("cityRole.noRbtBodyGeneric", "BT openings don't need it. Some cases do.")}
        </span>
        <a
          href={seoHref("how-to-become-an-rbt")}
          onClick={(e) => { e.preventDefault(); onNavigate("how-to-become-an-rbt"); }}
          style={{ display: "inline-flex", alignItems: "center", gap: 5, fontSize: 14, fontWeight: 800, color: "#047857", textDecoration: "underline" }}
        >
          {t("cityRole.noRbtLink", "How to get the RBT")} <ArrowRightIcon size={13} color="#047857" />
        </a>
      </div>
    </div>
  );
}
